import React from "react";
import { Linkedin, Instagram, Facebook, Youtube } from "lucide-react";
import BrandLogo from "./BrandLogo";

// ─── Custom inline SVGs for brands not in lucide ───────────────────────────────
const XIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const TikTokIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.85a8.16 8.16 0 0 0 4.77 1.52V6.93a4.85 4.85 0 0 1-1.84-.24z" />
  </svg>
);

const PinterestIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.987C24.007 5.367 18.641.001.017.001z" />
  </svg>
);

const ThreadsIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.781 3.631 2.695 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142c-.126-.742-.375-1.332-.74-1.757-.504-.582-1.279-.88-2.305-.881h-.043c-.762 0-1.799.197-2.456 1.247l-1.808-1.211c.853-1.371 2.235-2.123 4.265-2.123h.066c3.41.022 5.474 1.946 5.717 5.282.205.105.397.214.583.323 1.582.945 2.594 2.272 2.99 3.78.443 1.687.155 3.595-.93 5.165-1.232 1.78-3.121 2.704-5.617 2.745z" />
  </svg>
);

const BlueskyIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M5.203 2.987C7.92 5.029 10.84 9.169 11.91 11.39c1.071-2.221 3.99-6.36 6.708-8.402C20.58 1.51 23.726.412 23.726 4.024c0 .72-.413 6.05-.655 6.916-.842 3.013-3.914 3.78-6.648 3.315 4.78.814 6.001 3.512 3.373 6.211-4.993 5.13-7.176-1.288-7.736-2.932-.103-.302-.151-.443-.151-.323 0-.12-.048.02-.151.323-.56 1.644-2.743 8.062-7.736 2.932-2.628-2.699-1.407-5.397 3.373-6.211-2.734.465-5.806-.302-6.648-3.315C.5 10.073.087 4.745.087 4.024c0-3.612 3.146-2.514 5.116-1.037z" />
  </svg>
);

// ─── Socials list ───────────────────────────────────────────────────────────────
const SOCIALS = [
  { name: "LinkedIn",  Icon: Linkedin,      href: "https://www.linkedin.com/company/producers-today/about/" },
  { name: "X",         Icon: XIcon,         href: "https://x.com/producerstoday" },
  { name: "Instagram", Icon: Instagram,     href: "https://www.instagram.com/producers.today/?hl=en" },
  { name: "Facebook",  Icon: Facebook,      href: "https://www.facebook.com/people/ProducersToday/61589368363067/" },
  { name: "YouTube",   Icon: Youtube,       href: "https://www.youtube.com/@Producers-Today" },
  { name: "TikTok",    Icon: TikTokIcon,    href: "https://www.tiktok.com/@postemaconsultin2?lang=en" },
  { name: "Pinterest", Icon: PinterestIcon, href: "https://www.pinterest.com/producers_today/" },
  { name: "Threads",   Icon: ThreadsIcon,   href: "https://www.threads.com/@producers.today" },
  { name: "Bluesky",   Icon: BlueskyIcon,   href: "https://bsky.app/profile/producers-today.bsky.social" },
];

function SocialButton({ name, Icon, href }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={name}
      title={name}
      className="group w-10 h-10 rounded-sm flex items-center justify-center border border-white/10 bg-white/[0.02] hover:border-[#f5c451]/60 hover:bg-[#f5c451]/[0.08] transition-all duration-300"
    >
      <Icon className="w-4 h-4 text-white/70 group-hover:text-[#f5c451] transition-colors" strokeWidth={1.8} />
    </a>
  );
}

export default function Footer() {
  return (
    <footer className="relative pt-14 pb-10 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center lg:items-center justify-between gap-8 mb-10">
          {/* Brand */}
          <BrandLogo size="md" />

          {/* Socials */}
          <div className="flex flex-col items-center gap-3 mx-auto lg:mx-0">
            <div className="text-[10px] uppercase tracking-[0.22em] text-white/40 font-semibold">
              Follow Producers Today
            </div>
            <div className="flex flex-wrap items-center justify-center gap-2">
              {SOCIALS.map((s) => (
                <SocialButton key={s.name} {...s} />
              ))}
            </div>
          </div>

          {/* M&S Network credit */}
          <div className="flex items-center gap-3 mx-auto lg:mx-0">
            <img
              src="https://customer-assets.emergentagent.com/job_elite-portal-11/artifacts/ya7vam3j_Motivation%20%26%20Success%20Network%20White%20and%20Gold%202D%281%29.png"
              alt="Motivation & Success Network"
              className="w-14 h-14 rounded-md object-contain"
            />
            <div className="text-[10px] uppercase tracking-[0.18em] text-white/55 leading-tight">
              A Motivation &amp; Success<br />
              <span className="text-[#f5c451]">Network</span> Broadcast
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 text-center text-xs text-white/40">
          &copy; {new Date().getFullYear()} Producers Today&trade;. The Voice of the Producers. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
